import {
  FEATURE_RESTRICTION_UPGRADE_MODAL_HIDE,
  FEATURE_RESTRICTION_UPGRADE_MODAL_SHOW,
} from './types';

/**
 * Hide "Upgrade to MokaPos" modal.
 *
 * @return {Object}
 */
export function hideUpgradeModal() {
  return {
    type: FEATURE_RESTRICTION_UPGRADE_MODAL_HIDE,
  };
}

/**
 * Show "Upgrade to MokaPos" modal.
 *
 * @return {Object}
 */
export function showUpgradeModal() {
  return {
    type: FEATURE_RESTRICTION_UPGRADE_MODAL_SHOW,
  };
}
